// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d96d7acb","453":"7220ec14","455":"e58f77c9","977":"b3016a8a"}[chunkId] + ".chunk.js";
};